'use strict';

var AppState = require('app_state');
var CommonViews = require('components/common/views');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var Log = require('utils/log');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Requests = require('utils/requests');
var Strings = require('utils/strings');
var Theme = require('utils/theme/theme_controller');
var i18n = require('utils/i18n');

var App = new Backbone.Marionette.Application();

App.initializeAppStateCache = function (deleteStorage) {
    AppState.initializeDataCache(function () {
        return App.request.apply(App, arguments);
    }, deleteStorage);
};

App.initializeAppStateCache();

App.requestSilent = function (name) {
    return Marionette.Application.prototype.request.apply(App, arguments);
};

App.request = function (name) {
    Misc.Waiting.wait(name, Backbone.history.location.href);
    var result = Backbone.Marionette.Application.prototype.request.apply(App, arguments);

    var def = $.Deferred();

    $.when(result)
        .done(function () {
            Misc.Waiting.done(name);
            def.resolve.apply(undefined, arguments);
        })
        .fail(function () {
            Misc.Waiting.done(name);
            def.reject.apply(undefined, arguments);
        });

    return def.promise();
};

App.requestChannel = function (maxLimit) {
    return Misc.requestChannel(maxLimit, function (requestArgs) {
        return App.request.apply(null, arguments);
    });
};

App.requestDone = function () {
    var args = arguments;
    var reqArgs = [];
    for (var i = 0; i < args.length - 1; i++) {
        reqArgs[i] = args[i];
    }

    var req = App.request.apply(App, reqArgs);
    $.when(req).done(args[args.length - 1]);
};

App.demoUsers = [120, 193, 318, 330];
App.categories = undefined;

App.forceResize = function () {
    setTimeout(function () {
        // re-initialize based on window size
        $('body').trigger('resize');
    }, 100);
};

App.navigate = function (route, options) {
    options || (options = {});
    Backbone.history.navigate(route, options);
    AppState.route = route;
};

App.getCurrentRoute = function () {
    return Backbone.history.fragment;
};

App.errIfUndefined = function (data, errMsg, region, regionOwner) {
    if (data !== undefined) {
        return false;
    }

    var contentView = new CommonViews.Message({
        title: i18n.TR('Fehler'),
        text: errMsg,
        color_class: 'box-color-error',
    });

    if (region === false) {
        Notification.show('error', i18n.TR('Fehler'), errMsg);
        return true;
    }

    if (region && regionOwner) {
        regionOwner.showChildView(region, contentView);
    } else {
        App.showContentView(contentView);
    }

    return true;
};

App.BaseRouter = Marionette.AppRouter.extend({
    onRoute: function (trigger, path, params) {
        var route = App.getCurrentRoute();

        // new page? ->scroll to the top left corner of the page
        if (AppState.route != route) {
            window.scrollTo(0, 0);
            App.modal.reset();
        }

        if (AppState.route && Misc.removeQueryFromURL(AppState.route) != Misc.removeQueryFromURL(route)) {
            // route changed ..
            AppState.route = route;
            AppState.saveURLParameter();

            // .. refresh help information
            if (AppState.layout) {
                AppState.layout.updateHelpIcon();

                /*
				HINT: works more or less, needs testing and tuning

				// scroll to the top
				document.body.scrollTop = 0; // Safari
				document.documentElement.scrollTop = 0;
				*/
            }
        }
        App.forceResize();
    },
});

App.initializeModules = function (categories) {
    App.categories = categories;

    require('utils/polyfill');
    require('shared_data.generated');
    require('consts').initialize();

    // setup models
    require('models/address');
    require('models/alarms');
    require('models/charts');
    require('models/company');
    require('models/contact_person');
    require('models/devices');
    require('models/devices_status');
    require('models/feedback');
    require('models/gateway_connection_statistic');
    require('models/gateway_firmware_config');
    require('models/groups');
    require('models/heat_circuit');
    require('models/labels');
    require('models/mail');
    require('models/misc_info');
    require('models/modbus');
    require('models/overview');
    require('models/permissions');
    require('models/reports_device');
    require('models/rule');
    require('models/scheme');
    require('models/style');
    require('models/tools');
    require('models/users');
    require('models/value_specs');
    require('models/values');

    // setup routing
    require('components/account/account_component').initializeRouting();
    require('components/activation/activation_component').initializeRouting();
    require('components/help/help_component').initializeRouting();
    require('components/home/home_component').initializeRouting();
    require('components/profile/profile_component').initializeRouting();

    // setup components - I
    require('components/menubar/menubar_component');
    require('components/scheme/display_functions');
    require('utils/templates');
    require('utils/templates_svg');

    // setup theme
    require('utils/theme/notify');

    // setup (modified) 3rd-party libs
    require('utils/libs/momentjs_locale/de');
    require('utils/libs/jquery.multi-select');
    require('utils/libs/jquery.pageguide');

    // setup components - II
    require('consts').initializeCategories(categories);
    require('components/sidebar/sidebar_component').initialize();

    initDeviceCategoryObj();

    require('components/devices/devices_component').InstallDeviceCategories();
    require('models/devices').InitDeviceLists();
    require('components/devices/devices_component').initializeRouting();
};

function initDeviceCategoryObj() {
    var baseDeviceController = require('components/devices/controllers/base_device_controller');
    var oop = require('utils/oop');
    var consts = require('consts');

    var newBaseController = function (newCategory) {
        return oop.extend(baseDeviceController, {}, 'BaseController/' + newCategory);
    };

    App.DevicesCategoryObj = {};

    _.each(consts.AllCategoryData, function (cd, c) {
        App.DevicesCategoryObj[cd.category] = {
            controller: cd.base_controller ? newBaseController(c) : require(cd.controller),
            listView: require(cd.views.list),
            settingsView: require(cd.views.settings),
        };
    });
}

App.initializeCSRFprotection = function () {
    // -> add CSRF token for currently logged in user

    // wrap original Backbone sync method
    App._sync = Backbone.sync;
    Backbone.sync = function (method, model, options) {
        if (AppState.user) {
            options.beforeSend = function (xhr) {
                xhr.setRequestHeader(Consts.HeaderKeys.xTrovisToken, AppState.user.get('token'));
            };
        }
        options = callbackWrapper(options);
        return App._sync(method, model, options);
    };

    App.ajaxDeferred = function (ajaxReq) {
        var defer = $.Deferred();
        var newReq = _.clone(ajaxReq);
        newReq.success = function () {
            var result = ajaxReq.success ? ajaxReq.success.apply(defer, arguments) : true;
            if (!defer.noResolve) {
                defer.resolve(result);
            }
        };

        newReq.error = function () {
            var result = ajaxReq.error ? ajaxReq.error.apply(defer, arguments) : undefined;
            if (!defer.noResolve) {
                defer.resolve(result);
            }
        };

        setTimeout(function () {
            App.ajax(newReq);
        });
        return defer.promise();
    };

    // wrap original $.ajax method
    App.ajax = function (options) {
        if (AppState.user) {
            options.headers = {};
            options.headers[Consts.HeaderKeys.xTrovisToken] = AppState.user.get('token');
        }
        options = callbackWrapper(options);
        return $.ajax(options);
    };

    // callbackWrapper wraps the error- und success callback,
    // preventing them from beeing executed if their calling url has changed
    function callbackWrapper(options) {
        var url = Backbone.history.location.href;
        options.success = responseProxy(url, options.success);
        options.error = responseProxy(url, options.error);
        return options;
    }

    // responseProxy:
    // - omits callbacks belonging to an url the user already left
    // - updates the locked state of a device (if it was a device specific request)
    function responseProxy(url, func) {
        return function (params, responseText, xhr) {
            // update locked state of device, if given
            xhr = xhr || params;

            if (xhr.getResponseHeader) {
                var devLock = xhr.getResponseHeader(Consts.HeaderKeys.xDevLocked);
                if (devLock) {
                    AppState.setDeviceLockStatus(JSON.parse(atob(devLock)));
                }
            }

            if (!Strings.compareURL(url, Backbone.history.location.href)) {
                return;
            }

            func(params);
        };
    }
};

function listCategoriesReq() {
    var defer = $.Deferred();

    $.ajax({
        method: 'GET',
        url: '/api/v1/devices/categories',
        success: function (data) {
            var categoryMap = {};
            _.each(data, function (category) {
                categoryMap[category] = true;
            });
            defer.resolve(categoryMap);
        },
        error: function () {
            defer.resolve([]);
        },
    });

    return defer.promise();
}

function getOpenIDProviderReq() {
    var defer = $.Deferred();

    $.ajax({
        method: 'GET',
        url: '/api/v1/account/openid',
        success: function (data) {
            defer.resolve(data);
        },
        error: function () {
            defer.resolve([]);
        },
    });
    return defer.promise();
}

App.loadPlugins = function () {
    var pluginRequest = $.Deferred();
    $.getScript('/api/v1/content/plugins.js')
        .done(function () {
            if (window.SDE_plugins) {
                App.pluginState = Consts.pluginStates.READY;
            } else {
                App.pluginState = Consts.pluginStates.BROKEN;
            }
            pluginRequest.resolve();
        })
        .fail(function (resp) {
            switch (resp.status) {
                case 401:
                    // user not loged in
                    App.pluginState = Consts.pluginStates.NOT_LOADED;
                    break;
                case 404:
                    App.pluginState = Consts.pluginStates.NOT_DEFINED;
                    break;
                default:
                    App.pluginState = Consts.pluginStates.BROKEN;
            }
            pluginRequest.resolve();
        });
    return pluginRequest;
};

App.initialize = function () {
    Log.info('App::initialize');
    if (TC_DEBUG === true) {
        window.onerror = function (msg) {
            document.body.setAttribute('JSError', msg);
            document.body.setAttribute('StackTrace', arguments[4].stack);
        };
    }
    App.pluginState = Consts.pluginStates.NOT_LOADED;
    App.loadPlugins();
    AppState.lockedDevices = {};
    AppState.isSubdomain = Requests.getSubdomain(window.location.host) != '';

    var languageInit = require('utils/i18n').initialize();
    var messageInit = require('utils/messages').initialize();

    var self = this;
    $.when(listCategoriesReq(), getOpenIDProviderReq(), languageInit, messageInit).done(
        function (categories, openIDProvider) {
            if ('TC_INVALID' in window && TC_INVALID) {
                var urlParts = window.location.href.split('/');
                window.location.replace(urlParts[0] + '//' + urlParts[2] + '/404');
                return;
            }

            AppState.openIDProvider = openIDProvider;

            self.initializeModules(categories);
            self.initializeCSRFprotection();
            self.start();

            Theme.Init();
            self.forceResize();
        }
    );

    App.computeFingerprint();

    $(document).ajaxError(function (event, xhr) {
        if (xhr.status == 401) {
            // kick the user out
            AppState.destroyUser();
            App.initializeAppStateCache(true);
            // logged out -> redirect to login view
            App.trigger('login:show');
        }
    });
};

App.reInitialize = function () {
    require('consts').initialize();
    require('consts').initializeCategories(App.categories);

    Backbone.history.loadUrl(Backbone.history.fragment);
};

App.showModal = function (view) {
    Decorator.enableElement('.modal-dialog');
    $('#js-modal-dialog .modal-dialog').removeClass('modal-lg');
    $('#js-modal-dialog .modal-dialog').removeClass('modal-xl');
    App.modal.show(view);
    $('#js-modal-dialog').modal({ backdrop: 'static' });
    $('#js-modal-dialog').modal('show');
    // remove focus from all elements
    $('*').blur();
};

App.hideModal = function (view) {
    $('#js-modal-dialog').modal('hide');
    Decorator.enableElement('.modal-dialog');
    // App.modal.reset();  --> Might be a good idea. On the other hand, there
    //                         is no (simple!) possibility to intercept clicks on
    //                         the modal backdrop - and call 'reset' in these
    //                         cases. Therefore: never call 'reset' the last
    //                         dialog stays - invisible - in the page DOM.
};

App.refreshModal = function (view) {
    view.render();
    Decorator.enableElement('.modal-dialog');
};

App.showContentView = function (view, permissions) {
    if (permissions !== undefined) {
        // inject permissions -> used (for example) to distinguish
        // read-only mode from full access mode
        view.setPermission(permissions);
    }
    AppState.layout.showChildView('content', view);
};

App.addRegions({
    main: '#app',
    modal: '#modal',
});

App.fingerprintComputation = $.Deferred();

App.computeFingerprint = function () {
    var cb = function (hash) {
        App.browserFingerprint = hash;
        App.fingerprintComputation.resolve(hash);
    };

    if (window.requestIdleCallback) {
        requestIdleCallback(function () {
            Fingerprint2.getV18(cb);
        });
    } else {
        setTimeout(function () {
            Fingerprint2.getV18(cb);
        }, 500);
    }
};

App.on('start', function () {
    Log.info('App::start');
    if (Backbone.history) {
        if (!Backbone.history.start()) {
            App.trigger('404');
        }
    }
});

App.on('404', function () {
    App.main.show(new CommonViews.NotFound());
});

module.exports = App;
